jQuery(document).ready(function($) {

    $('.copy-link button').on('click', function(e) {
        e.preventDefault();

        const imageURL = $(this).parent().prev().find('img').attr('src');

        copyTextToClipboard(imageURL.replace('_thumb.', '.').replace('/files', document.location.origin))

        addNotice( $(this) );
    })

    $('.copy-link-index').on('click', function(e) {
        e.preventDefault();

        const imageURL = $(this).parent().prev().find('a').attr('href');

        copyTextToClipboard(imageURL)

        addNotice( $(this) );
    })

    function addNotice( element ) {

        element.append('<span class="copied-notice">Copied!</span>');
        setTimeout(function() {
            element.find('.copied-notice').fadeOut();
        }, '2000');
    }

    function copyTextToClipboard(text) {
        if (!navigator.clipboard) {
            fallbackCopyTextToClipboard(text);
            return;
        }
        navigator.clipboard.writeText(text).then(function() {
            console.log('Async: Copying to clipboard was successful!');
        }, function(err) {
            console.error('Async: Could not copy text: ', err);
        });
    }

    function fallbackCopyTextToClipboard(text) {
        var textArea = document.createElement("textarea");
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
    }


});